<template>
  <div class="d d_cy">
    <ul class="u4 u4_tit u_title">
      <li class="u4-3">选项</li>
      <li class="u4-3">已评定总数</li>
      <li class="u4-3">已评定比例</li>
    </ul>
    <div class="cnt_list">
      <ul class="u4 u4_tit u_cy u9" v-for="(item, index) in newList" :key="index">
        <li class="u4-3" v-if="item.twoStar && item.total > 0">二星章</li>
        <li class="u4-3" v-if="item.threeStar && item.total > 0">三星章</li>
        <li class="u4-3" v-if="item.twoOrThreeStar && item.total > 0">二星章或三星章</li>
        <li class="u4-3" v-if="item.fourStar && item.total > 0">四星章</li>
        <li class="u4-3" v-if="item.total > 0">{{ item.total }}</li>
        <li class="u4-3" v-if="item.total > 0">{{ percent(item.total) }}%</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, watch } from "vue";
import _ from "lodash";

export default {
  name: "HLJMedal",
  props: {
    list: Array,
  },
  setup(props) {
    const state = reactive({
      newList: [
        { redScarfMedal: 1, twoStar: 1, total: 0 },
        { redScarfMedal: 1, threeStar: 1, total: 0 },
        { redScarfMedal: 1, twoOrThreeStar: 1, total: 0 },
        { redScarfMedal: 1, fourStar: 1, total: 0 },
      ],
      total: 0,
    });

    watch(props, (newProps) => {
      const {
        list: { redScarfMedalStar },
      } = newProps;
      console.log("list", redScarfMedalStar.length, redScarfMedalStar);
      if (redScarfMedalStar.length > 0) {
        calculation(redScarfMedalStar);
      }
    });

    const percent = (value = 0) => {
      const { total } = state;
      if (value == 0 || total == 0) {
        return 0;
      }
      return ((value / total) * 100).toFixed(2);
    };

    const calculation = (list) => {
      const { newList } = state;
      // 计算总和
      const total = _.sumBy(list, function (o) {
        return o.total;
      });
      state.total = total;

      let twoTotal = 0,
        threeTotal = 0,
        fourTotal = 0,
        ttTotal = 0;

      for (const nl of list) {
        if (nl.twoStar && nl.twoStar == 1) {
          twoTotal += nl.total;
        }
        if (nl.threeStar && nl.threeStar == 1) {
          threeTotal += nl.total;
        }
        if (nl.fourStar && nl.fourStar == 1) {
          fourTotal += nl.total;
        }
        if (nl.twoOrThreeStar && nl.twoOrThreeStar == 1) {
          ttTotal += nl.total;
        }
      }

      for (let i = 0; i < newList.length; i++) {
        if (newList[i].twoStar) {
          newList[i].total = twoTotal;
        }
        if (newList[i].threeStar) {
          newList[i].total = threeTotal;
        }
        if (newList[i].fourStar) {
          newList[i].total = fourTotal;
        }
        if (newList[i].twoOrThreeStar) {
          newList[i].total = ttTotal;
        }
      }
    };

    return {
      ...toRefs(state),
      percent,
    };
  },
};
</script>

<style lang="less" scoped>
@import "@/common/style/mixin";

.u9 {
  background-color: #f8fafc;
  display: flex;
}
.u9:nth-child(2n + 1) {
  background-color: #fff;
}
.u_title {
  background-color: #e5e7eb;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px 8px 0 0;
}
.u4_tit {
  height: auto;
  line-height: auto;
}
.u4_tit li {
  border-right: 1px solid #dcdcdc;
  margin-right: -1px;
}
.u4 li {
  width: 50%;
}
.total_title {
  font-size: 0.42rem;
  padding: 0.233rem;
}
.line {
  border-bottom: 1px dashed #dcdcdc;
  margin: 0.5rem 0;
}
.cnt_list {
  border: 1px solid #e5e7eb;
}
.u_cy li {
  min-height: auto;
  line-height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.u4_tit1 {
  border-right: none !important;
}
</style>
